import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { FurnitureEditorContext } from 'lib/constraintsChecker/FurnitureEditor';
import {
  makeSelectContext,
  makeSelectIsVisiblePieceList,
  makeSelectIsVisibleViewer,
} from 'containers/Configurator/selectors/general';
import {
  displayPiecesListAction,
  displayViewerAction,
} from 'containers/Configurator/actions/general';
import { useTranslation } from 'react-i18next';
import { useMedia } from 'use-media';
import { loadFurnitureAction } from 'containers/Configurator/actions/furniture';
import { BASE_CABINET } from 'containers/Configurator/constants/furniture';
import TestData from './TestData';
import { FaWindowClose } from 'react-icons/fa';
import { convertProblems, sideDepthProblems } from '../../helpers/conversions';
import ContextSwitcher from './ContextSwitcher';
import AddReference from '../AddReference';
import { convertCabinet } from '../../lib/modelBuilder/utils/conversionUtils/generatorOldCabinets';

interface Props {
  className?: string;
}

interface StateProps {
  context: FurnitureEditorContext;
  isVisiblePieceList: boolean;
  isVisibleViewer: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  context: makeSelectContext(),
  isVisiblePieceList: makeSelectIsVisiblePieceList(),
  isVisibleViewer: makeSelectIsVisibleViewer(),
});

function ControlConfigurator({ className }: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { context, isVisiblePieceList, isVisibleViewer } = useSelector(
    stateSelector,
  );
  const isMobile = useMedia({ maxWidth: 1023 });

  if (
    process.env.NODE_ENV === 'production' &&
    context === FurnitureEditorContext.webShop
  )
    return null;

  if (isMobile) return null;

  const closeConfigurator = () => {
    // @ts-ignore
    $.fancybox.close();
  };

  return (
    <div className={className}>
      {/*<div className="text-base mx-2">Configurator infos:</div>*/}
      <div className="flex justify-between">
        <div className="flex items-center">
          <ContextSwitcher />
          <div className="text-sm mx-1">
            <button
              onClick={() => {
                dispatch(displayPiecesListAction());
              }}
              className="border px-3 py-1 rounded"
            >
              {isVisiblePieceList ? t('Hide') : t('Show')} {t('piece list')}
            </button>
          </div>
          {process.env.NODE_ENV !== 'production' && (
            <div className="text-sm mx-1">
              <button
                onClick={() => {
                  dispatch(displayViewerAction(!isVisibleViewer));
                }}
                className="border px-3 py-1 rounded"
              >
                {isVisibleViewer ? t('Hide') : t('Show')} {t('viewer')}
              </button>
            </div>
          )}
          <div className="text-sm mx-1">
            <button
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_CABINET));
              }}
              className="border px-3 py-1 rounded"
            >
              {t('Reset')}
            </button>
          </div>
          <AddReference />

          {/*<div>
          <StyledTestEventStyledComponenent
            onClick={() => {
              throw new Error('Test Event');
            }}
            aria-label="Don't worry, this is just a test"
          >
            Error test
          </StyledTestEventStyledComponenent>
        </div>*/}
          {process.env.NODE_ENV !== 'production' && (
            <div>
              <button
                onClick={() => {
                  // dispatch(loadFurnitureAction(getNextOldCabinetId(), true));
                  // dispatch(loadFurnitureAction('328850915', true));
                  // convertAndSaveAll();
                  // convertAndSaveAllCheck();
                  // convertProblems();
                  // sideDepthProblems();
                  // convertAll();
                  convertCabinet('327920119');
                  //   .then(cabinet => {
                  //     console.log(`The cabinet ${cabinet.id} is loaded`);
                  //   })
                  //   .catch(() => {
                  //     console.log('KO');
                  //   });
                }}
                className="border px-3 py-1 rounded text-sm"
              >
                Convert Next
              </button>
            </div>
          )}
        </div>
        {process.env.NODE_ENV !== 'production' ||
        context !== FurnitureEditorContext.webShop ? (
          <div className="text-sm mx-1">
            <button
              onClick={closeConfigurator}
              className="border px-3 py-1 rounded flex items-center"
            >
              <FaWindowClose className="h-4 w-4 mr-2" />
              <div>{t('Close configurator')}</div>
            </button>
          </div>
        ) : null}
      </div>
      {process.env.NODE_ENV !== 'production' && <TestData />}
    </div>
  );
}

export default ControlConfigurator;

/*const StyledTestEventStyledComponenent = styled.button`
  padding: 0.25rem 0.5rem;
  background-color: ${p => p.theme.main};
  color: white;
`;*/
